/* eslint-disable */

const getters = {
  // --- Suprazones ---  
  suprazones: state => state.suprazones.suprazones,

  pickupzones: state => state.pickupzones.pickupzones,
  pickupzone: state => state.pickupzones.pickupzone,
  subzones: state => state.subzones.subzones,
  subzone: state => state.subzones.subzone,
  geopoints: state => state.geopoints.geopoints,
  geopoint: state => state.geopoints.geopoint,
  groups: state => state.groups.groups,

  // --- Filters ---//
  filters: state => state.filters.filters,
  filtersLength: state => state.filters.filters.length,
  filterSuprazone: state => state.filters.filters.suprazone,
  filterDate: state => state.filters.filters.date,
  filterGroup: state => state.filters.filters.group,
  filterPickupzone: state => state.filters.filters.pickupzone,

  currentSuprazone: state => state.suprazones.suprazones.filter(
    el => el.id === state.filters.filters.suprazone
  )[0],
  currentGroup: state => state.groups.groupsListAdmin.filter(
    el => el.id === state.filters.filters.group
  )[0],

  // --- Buses ---
  buses: state => state.buses.buses,
  excursionBuses: state => state.buses.excursionBuses,
  pickupBuses: state => state.buses.pickupBuses,
  returnBuses: state => state.buses.returnBuses,
  bus: (state) => (id) => state.buses.buses.find(bus => bus.id == id),
  busExcursion: (state) => (id) => state.buses.excursionBuses.find(bus => bus.id == id),
  busPickup: (state) => (id) => state.buses.pickupBuses.find(bus => bus.id == id),
  busReturn: (state) => (id) => state.buses.returnBuses.find(bus => bus.id == id),

  idBusExcursionType: (state) => (id) => state.buses.excursionBuses.find(bus => bus.id == id).bustype_set.find(busType => busType.bus_type == 'Excursion'),
  idBusPickupType: (state) => (id) => state.buses.pickupBuses.find(bus => bus.id == id).bustype_set.find(busType => busType.bus_type == 'Pickup'),
  idBusReturnType: (state) => (id) => state.buses.returnBuses.find(bus => bus.id == id).bustype_set.find(busType => busType.bus_type == 'Return'),

  allBusesLessOne: (state) => (id) => state.buses.buses.filter(bus => bus.id != id),
  hasBookings: state => state.buses.hasBookings,

  // --- Bookings ---
  bookings: state => state.bookings.bookings,
  bookingsUnassigned: state => state.bookings.bookingsUnassigned,
  bookingsOrphanGroup: state => state.bookings.bookingsOrphanGroup,
  bookingsByActivity: state => state.bookings.bookingsByActivity,
  bookingsByActivityForCheck: state => state.bookings.bookingsByActivityForCheck,
  bookingsByExcursionBus: state => state.bookings.bookingsByExcursionBus,
  bookingsByPickupBus: state => state.bookings.bookingsByPickupBus,
  bookingsByReturnBus: state => state.bookings.bookingsByReturnBus,
  bookingsByStop: state => state.bookings.bookingsByStop,

  busesPaths: state => state.buses.busesPath,
  busPath: state => (busId) => state.buses.busesPath.filter(bus => bus.bus_id == busId),
  planningCommunicationsData: state => state.buses.sentPlanningData,

  // --- Booking ---
  booking: state => (id, activeTab) => {
    let list = []
    if ( activeTab === 'Excursions') {
      list = state.bookings.bookingsByActivity
    } else if ( activeTab === 'Pickups') {
      list = state.bookings.bookingsByStop
    } else if ( activeTab === 'Returns') {
      list = state.bookings.bookingsByReturnBus
    } else if ( activeTab === 'Check') {
      list = state.bookings.bookingsByActivityForCheck
    } else if ( activeTab == 'Unassigned') {
      console.log("activeTab in getters.js "+ activeTab)
      list = state.bookings.bookingsUnassigned
      console.log(list)
      //list = list.concat(state.bookings.bookingsOrphanGroup)
      console.log(list)
      let b = list.find(booking => booking.id == id)
      console.log("booking " + b)
      if ( b != undefined ) {
        return b
      }
    } else if ( activeTab == 'Orphan' ) {
      list = state.bookings.bookingsOrphanGroup
      let b = list.find(booking => booking.id == id)
      console.log("booking " + b)
      if ( b != undefined ) {
        return b
      }
    }
    for ( let idx in list ) {
      let booking = list[idx].bookings_list.find(booking => booking.id == id)
      if ( booking != undefined ) {
        return booking
      }
    }
  },

  // --- Pickupzone bookings summary ---
  pickupzoneSummary: state => state.bookings.bookingsByPickupzoneSummary,

  // --- Stops ---
  stops: state => state.stops.stops,

  // Number of bookings that have been assigned to a bus
  allResAssigned: (state) => (id) => state.bookings.bookings.filter(res => res.bus != null && res.bus.id == id).length,
  // All bookings that have been assigned to a specific bus
  allResOnABus: (state) => (id) => state.bookings.bookings.filter(res => res.bus.id == id),

  //trekksoft
  trekksoftData: state => state.trekksoft.trekksoft_data,
  trekksoftClient: state => state.trekksoft.trekksoft_client,

  //auth
  jwt: state => state.auth.jwt,

  //Loading Status
  isDataLoading: state => state.loading.isLoading || state.loading.isBookingLoading || state.loading.isGeneralLoading || state.loading.isBusLoading,
  isGeneralLoading: state => state.loading.isGeneralLoading,
  isBookingLoading: state => state.loading.isBookingLoading,
  isOrphanBookingsLoading: state => state.loading.isOrphanBookingsLoading,
  isBookingsForCheckingLoading: state => state.loading.isBookingsForCheckingLoading,
  isBusLoading: state => state.loading.isBusLoading,
  isLoading: state => state.loading.isLoading,

  username: state => state.auth.username,

  // --- HOTELS ---
  hotels: state => state.hotels.hotels,
  hotelsByName: state => state.hotels.hotelsByName,

  // --- activities admin ---
  activities: state => state.activities.activities,

  // tabs and active options
  activeTab: state => state.layout.activeTab,
  activeOption: state => state.layout.activeOption,

  // admin
  stopsAdmin: state => state.stops.stopsAdmin,
  geopointsWithoutStopScheduleAdmin: state => state.geopoints.geopointsWithoutStopScheduleAdmin, 
  geopointsListAdmin: state => state.geopoints.geopointsListAdmin,
  toggleGeopointLitAdmin: state => state.geopoints.toggleGeopointLitAdmin,
  geopointsWithoutZoneAdmin: state => state.geopoints.geopointsWithoutZoneAdmin,
  suprazoneAdminCurrent: (state) => (id) => state.suprazones.suprazones.find(item => item.id == id),
  stopsAdminCurrent: (state) => (id) => state.stops.stopsAdmin.find(item => item.id == id),
  activityGroupCurrent: (state) => (id) => state.groups.groups.find(item => item.id == id),
  pickupzonesListAdmin: state => state.pickupzones.pickupzonesListAdmin,
  subzonesListAdmin: state => state.subzones.subzonesListAdmin,
  subzonesAllListAdmin: state => state.subzones.subzonesAllListAdmin,
  groupsListAdmin: state => state.groups.groupsListAdmin,

  // guides
  guides: state => state.guides.guides,
  guideById: (state) => (id) => state.guides.guides.find(guide => guide.id == id),

  // analytics breakdown guides
  analyticsBreakdown: state => state.analytics.breakdownGuides,
  // get filter attributes from analytics screen
  guideAnalyticsFilter: state => state.analytics.guidesFilter,

  // get bus companies
  busCompanies: state => state.buscompanies.busCompanies,

  // get bus companies prices
  busCompaniesPrices: state => state.buscompaniesprices.busCompaniesPrices,

  // get bus fare types
  busFareTypes: state => state.busFareTypes.busFareTypes,

  // get activity duration types
  activityDurationTypes: state => state.activityDurationTypes.activityDurationTypes,

  // get filter attributes from analytics screen (bus companies)
  busCompaniesAnalyticsFilter: state => state.analytics.busCompaniesFilter,

  // get bus companies filter
  busCompaniesBreakdown: state => state.analytics.breakdownBusCompanies,

  // get hotel, stops by activity group
  hotelStopGroups: state => state.hotelStopGroups.hotelStopGroups,

  // get hotel to edit from UI
  hotelEdit: state => state.hotelStopGroups.hotelEdit,
  groupBulkPickupEdit: state => state.hotelStopGroups.groupBulkPickupEdit,
  // force UI reload of hotels, activity group, pickup relations
  forceUIReload: state => state.hotelStopGroups.forceUIReload,

  // get bookingsWideView state
  bookingsWideView: state => state.layout.bookingsWideView,
  // get busWideView state
  busWideView: state => state.layout.busWideView,
}

export default getters